var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyWhiteBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 258,
    viewBox: "0 0 288 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_12458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.245 162.766C227.245 162.766 258.54 188.044 257.182 210.567C255.825 233.089 238.068 261.491 186.301 257.669C134.534 253.848 142.276 213.947 142.276 213.947C142.276 213.947 143.009 255.428 100.084 255.428C57.1596 255.428 14.8585 225.667 22.4896 182.422C30.1207 139.178 97.1861 141.823 97.1861 141.823L227.245 162.766Z",
    fill: "#EBECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.724 70.2869V150.494L234.032 103.759L145.724 70.2869Z",
    fill: "#D6D7DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4448 119.043V221.589L142.276 255.391V148.804L54.4448 119.043Z",
    fill: "#C8C3FF",
    stroke: "#766AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4448 119.043L145.724 70.2869V150.494L142.276 152.331L54.4448 119.043Z",
    fill: "#EBECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.276 255.391V152.331L234.032 103.759V206.966L142.276 255.391Z",
    fill: "#F2F1FF",
    stroke: "#766AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.726 78.517L234.032 103.759L145.724 70.2869L195.767 43.5757L281.726 78.517Z",
    fill: "#E4E1FF",
    stroke: "#766AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.276 152.331L92.6736 178.564L6.75049 144.542L54.4448 119.043L142.276 152.331Z",
    fill: "#E4E1FF",
    stroke: "#766AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4096 118.715L1.64278 98.7194L91.829 50.2232L144.958 70.3643L54.4096 118.715Z",
    fill: "#E4E1FF",
    stroke: "#766AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.56 124.04L195.51 172.465L142.276 152.331L234.032 103.759L287.56 124.04Z",
    fill: "#E4E1FF",
    stroke: "#766AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_12458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 258,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWhiteBox);
export default __webpack_public_path__ + "static/media/empty-white-box.ef8e1ecaa19db320abe165d08596dde7.svg";
export { ForwardRef as ReactComponent };